import { render, staticRenderFns } from "./RecommendedEPScore.vue?vue&type=template&id=abb9d43c&scoped=true"
import script from "./RecommendedEPScore.vue?vue&type=script&lang=js"
export * from "./RecommendedEPScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb9d43c",
  null
  
)

export default component.exports